import { DownloadOptions, DownloadTemplateVM } from './types';

export const DEFAULT_DOWNLOAD_OPTIONS: DownloadOptions = {
  seat_count_analysis: false,
  summary_calcs: false,
  worksheet: {
    shouldRowsShowClosed: false,
    shouldRowsShowOpen: false,
  },
  worksheet_with_notes: {
    shouldRowsShowClosed: false,
    shouldRowsShowOpen: false,
  },
  program_summary: {
    shouldRowsShowClosed: false,
    shouldRowsShowOpen: false,
  },
  program_notes: false,
};

export const EMPTY_TEMPLATE: DownloadTemplateVM = {
  config: {
    png: {},
    pdf: {},
  },
  formatConfigs: [
    {
      format: 'pdf',
      showClientFacingNames: false,
      showRsf: false,
    },
    { format: 'png', showClientFacingNames: false, showRsf: false },
  ],
};

export const MAX_TEMPLATE_NAME_LENGTH = 35;
export const MAX_DOWNLOAD_NAME_LENGTH = 25;
